import { Link, useNavigate, useLocation } from "react-router-dom";
import { LOGO_URL, scrollToId } from "./shared";
import TermsDialog from "./TermsDialog";
import { services } from "../data/services";

const companyLinks = [
  { label: "About", id: "about" },
  { label: "Why Us", id: "why-us" },
  { label: "Contact", id: "contact" },
];

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const go = (id) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(id), 120);
    } else {
      scrollToId(id);
    }
  };

  const linkCls = "text-sm text-[#a0aec0] transition-colors hover:text-white";

  return (
    <footer data-testid="footer" className="relative overflow-hidden border-t border-white/10">
      <div className="mx-auto max-w-7xl px-6 py-14">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-2">
            <img
              src={LOGO_URL}
              alt="Gabicom"
              className="h-24 w-auto object-contain"
            />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-[#a0aec0]">
              Your single partner for IT consulting, hardware, cloud, cybersecurity,
              creative design and support.
            </p>
          </div>

          <div>
            <p className="font-mono-tech text-xs uppercase tracking-widest text-[#00f0ff]">
              Services
            </p>
            <ul className="mt-4 space-y-2">
              {services.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/services/${s.slug}`}
                    data-testid={`footer-service-${s.slug}`}
                    className={linkCls}
                  >
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono-tech text-xs uppercase tracking-widest text-[#00f0ff]">
              Company
            </p>
            <ul className="mt-4 space-y-2">
              {companyLinks.map((c) => (
                <li key={c.id}>
                  <button onClick={() => go(c.id)} className={linkCls}>
                    {c.label}
                  </button>
                </li>
              ))}
              <li>
                <TermsDialog>
                  <button data-testid="footer-terms-link" className={linkCls}>
                    Terms &amp; Conditions
                  </button>
                </TermsDialog>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 md:flex-row">
          <p className="text-xs text-[#5a6478]">
            © 2021 Gabicom LLC. All rights reserved.
          </p>
          <p className="font-mono-tech text-xs uppercase tracking-widest text-[#5a6478]">
            IT Support &amp; Creative Solutions
          </p>
        </div>
      </div>
      <div className="font-display pointer-events-none select-none whitespace-nowrap text-center text-[18vw] font-bold leading-none text-white/[0.03]">
        GABICOM
      </div>
    </footer>
  );
}
